export enum AccountSyncResult {
    IDLE = 'IDLE',
    SYNCING = 'SYNCING',
    ERROR_RESYNC_NEEDED = 'ERROR_RESYNC_NEEDED',
    ERROR_PLAID_RELINK_NEEDED = 'ERROR_PLAID_RELINK_NEEDED',
    ERROR_PERMANENT = 'ERROR_PERMANENT',
    ERROR_PHANT_INTERNAL = 'ERROR_PHANT_INTERNAL'
}

export class AccountSyncStatusModel {
    accountId: string;
    id: number;
    syncResult: AccountSyncResult;
    error: string;
}
